import { DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { API_DATE_FS } from './shared';

const VALID_STATES = ['NSW', 'QLD', 'NT', 'SA', 'ACT', 'WA', 'TAS', 'VIC'];

const DRIVER_LICENCE_CLASSES = [
  'Car',
  'Motorcycle',
  'Light Rigid',
  'Medium Rigid',
  'Heavy Rigid',
  'Heavy Combination',
  'Multi-Combination',
  'Restricted Motorcycle',
  'Unrestricted Motorcycle',
  'Provisional (P1&P2)',
  'Learner',
];

const DRIVER_LICENCE_RESTRICTIONS = [
  'Automatic Transmission (A)',
  'Alcohol Interlock (I)',
  'Glasses or Corrective Lenses (S)',
  'Vehicle Modifications (V)',
  'Miscellaneous (X)',
  'None',
];

// TODO: fix the spelling of "license" to "licence" in the UI + API + DB
export class DlDriverLicenseFormItems extends PureComponent {
  static slug = 'dldriverlicense';

  constructor(props) {
    super(props);
    this.state = {};
  }

  static getSubmissionData(checkData, constituent) {
    return {
      identifier: checkData.identifier,
      ...checkData.expiry && { expiry: checkData.expiry.format(API_DATE_FS) },
      issued_by: checkData.issued_by,
      licenseClass: checkData.licenseClass,
      restrictions: checkData.restrictions,
      fullName: constituent.get('fullName'),
    };
  }

  disablePastDate = current => current && current < moment().endOf('day');

  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;
    const { slug } = this.constructor;

    const ident = {
      label: 'Identifier',
      slug: `${slug}.identifier`,
    };
    const expiry = {
      label: 'Expiry',
      slug: `${slug}.expiry`,
    };
    const issued_by = {
      label: 'State',
      slug: `${slug}.issued_by`,
    };
    const licenseClass = {
      label: 'Licence Class',
      slug: `${slug}.licenseClass`,
    };

    const restrictions = {
      label: 'Restrictions',
      slug: `${slug}.restrictions`,
    };

    return (<>
      <Form.Item label={ident.label}>
        {getFieldDecorator(ident.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${ident.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Input
            disabled={disabled}
          />,
        )
        }
      </Form.Item>
      <Form.Item label={expiry.label}>
        {getFieldDecorator(expiry.slug, {
          rules: [
            {
              required: true,
              message: 'Expiry is required',
            },
            ...(rules || []),
          ],
        })(
          <DatePicker
            format="DD-MM-YYYY"
            placeholder="DD-MM-YYYY"
            disabled={disabled}
            disabledDate={this.disablePastDate}
          />,
        )}
      </Form.Item>
      <Form.Item label={issued_by.label}>
        {getFieldDecorator(issued_by.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${issued_by.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Select
            showSearch
            disabled={disabled}
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase())
            }
          >
            {
              VALID_STATES.map(member => (
                <Select.Option key={member} value={member}>
                  {member}
                </Select.Option>
              ))}
          </Select>,
        )
        }
      </Form.Item>
      <Form.Item label={licenseClass.label}>
        {getFieldDecorator(licenseClass.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${licenseClass.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Select
            showSearch
            disabled={disabled}
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase())
            }
          >
            {
              DRIVER_LICENCE_CLASSES.map(member => (
                <Select.Option key={member} value={member}>
                  {member}
                </Select.Option>
              ))}
          </Select>,
        )
        }
      </Form.Item>
      <Form.Item label={restrictions.label}>
        {getFieldDecorator(restrictions.slug, {
          rules: [
            {
              required: true,
              message: `${restrictions.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Select
            showSearch
            disabled={disabled}
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase())
            }
          >
            {
              DRIVER_LICENCE_RESTRICTIONS.map(member => (
                <Select.Option key={member} value={member}>
                  {member}
                </Select.Option>
              ))}
          </Select>,
        )
        }
      </Form.Item>

    </>);
  }
}
